import React from "react";

function FireDetection() {
  return (
    <div class="col-lg-8 col-md-12 col-sm-12 content-side">
      <div class="service-details-content">
        <div class="inner-box">
          <h2>Fire Detection & Alarm System</h2>
          <figure class="image-box">
            <img
              src="assets/images/fire-alarm-and-fire-detection-systems-prevent-damages.jpg"
              alt=""
            />
          </figure>
          <div class="text">
            <h4 style={{ paddingTop: "1rem" }}>Intelligent Addressable</h4>
            <p>
              Our Intelligent Addressable Systems offer benefits in terms of
              speed of detection, identification of the location of the fire,
              and easier maintenance. Intelligent systems also offer tolerance
              with regard to faults in system wiring — this allows a single pair
              of wires to be used to connect up to 200 devices to the system,
              enabling cost savings.
            </p>
            <h4>Conventional</h4>
            <p>
              The Conventional Fire Alarm System provides the earliest
              practicable fire detection and warning. The system consists of
              detectors at designated locations, to detect smoke or heat at the
              earliest during a fire outbreak.
            </p>
            <h4>Hybrid</h4>
            <p>
              The Hybrid Fire Alarm System combines the capabilities of both
              Intelligent Addressable and Conventional Fire Alarm Systems.
            </p>
          </div>
          {/* <div class="two-column">
            <div class="row align-items-center clearfix">
              <div class="col-lg-6 col-md-6 col-sm-12 image-column">
                <figure class="image-box">
                  <img
                    src="http://azim.commonsupport.com/Firbrigs/assets/images/service/service-8.jpg"
                    alt=""
                  />
                </figure>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 content-column">
                <div class="text">
                  <h3>Fire Safety Tips</h3>
                  <h4>
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum.
                  </h4>
                  <ul class="list clearfix">
                    <li>Install smoke alarms in your home</li>
                    <li>Test smoke alarms every month</li>
                    <li>About a fire escape plan and practice</li>
                    <li>Think of fire before it starts</li>
                    <li>Read fire stop prevention Program</li>
                    <li>get out before the smoke gets thick</li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default FireDetection;
